<template>
  <woot-modal :show.sync="show" :on-close="onClose" size="modal-big">
    <woot-modal-header
      :header-title="`SEND MEDIA ASSET`"
    />
    <div class="modal-content flex flex-col items-center">
      <div>
        <h6>1. Select existing media assets:</h6>
        <div class="media-to-select">
          <div v-for="(mediaAsset, i) in [newMedia, ...localMediaAssets]" :key="mediaAsset.id">
            <button
              v-if="mediaAsset.url"
              @click="toggleMediaAsset(mediaAsset)"
              :class="{'selected-media-asset': selectedMediaAssetId === mediaAsset.id}"
            >
              <img :src="mediaAsset.url" :class="`media-asset-image`" />
            </button>
          </div>
        </div>
      </div>
      <div>
        <h6>Or upload new one:</h6>
        <input
          type="file"
          name="media_asset"
          @change="onChangeFile"
        />
      </div>
      <div>
        <h6>2. Credits to unlock</h6>
        <input
          type='number'
          min='0'
          v-model.number="creditsToUnlock"
          class="credit-to-unlock-field mb-0 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 border-slate-200 dark:border-slate-600"
        />
      </div>
      <div>
        <button
          class="mt-2 button primary"
          @click="sendMessage"
          :disabled="!isValid"
        >
          Send media
        </button>
      </div>
    </div>
  </woot-modal>
</template>

<script>

import MessageApi from '../../../../api/inbox/message';
export default {
  props: {
    inboxId: {
      type: Number,
      default: undefined,
    },
    show: {
      type: Boolean,
      default: true,
    },
    conversationId: {
      type: Number,
      default: undefined,
    }
  },
  data() {
    return {
      selectedMediaAssetId: '',
      creditsToUnlock: 0,
      newMedia: {},
    };
  },
  computed: {
    localMediaAssets() {
      return this.$store.getters['inboxes/getLocalMediaAssets'](this.inboxId);
    },
    isValid() {
      return this.selectedMediaAssetId &&
      Number.isInteger(this.creditsToUnlock) &&
      this.creditsToUnlock >= 0;
    }
  },
  methods: {
    toggleMediaAsset(mediaAsset) {
      if (this.selectedMediaAssetId == mediaAsset?.id)
        this.selectedMediaAssetId = '';
      else
        this.selectedMediaAssetId = mediaAsset.id;
    },
    sendMessage() {
      const formData = new FormData();
      formData.append("media_asset_id", this.selectedMediaAssetId);
      formData.append("content_attributes[credit_to_unlock]", this.creditsToUnlock);
      if (this.newMedia.file) {
        formData.append("attachment", this.newMedia?.file, this.newMedia?.file?.name);
      }

      MessageApi.createMediaMessage(this.conversationId, formData).then(res => {
        // trigger reload new media assets for all inboxes
        this.$store.dispatch('inboxes/get');
      });
      this.onClose();
    },
    onClose() {
      this.creditsToUnlock = 0;
      this.selectedMediaAssetId = '';
      this.newMedia = {};
      this.$emit('cancel');
    },
    onChangeFile(event) {
      console.log(file)
      this.newMedia = {
        file: event.target.files[0],
        url: URL.createObjectURL(event.target.files[0]),
        id: 'new_media'
      }
      this.selectedMediaAssetId = 'new_media';
    },
  }
};
</script>

<style scoped lang="scss">
@import '~widget/assets/scss/variables.scss';

.modal-content {
  padding: 1.5625rem 2rem;
}

.media-to-select {
  max-height: 280px;
  display: grid;
  grid-template-columns: auto auto auto;
  overflow: auto;
  margin-bottom: 20px;
  column-gap: 5px;
  row-gap: 5px;
}

.selected-media-asset {
  border: 5px solid $color-woot;
}

.credit-to-unlock-field  {
  width: 200px;
}

.media-asset-image {
  width: 200px;
  height: auto;
}

h6  {
  text-align: center;
}
</style>

